/* Enalika - cinematic layer.

   Same two gotchas as enalika-motion.js apply and are handled the same way:
   1. This theme scrolls .page-wrapper, not the window, so listen on document
      in the CAPTURE phase - scroll does not bubble but capture still sees it.
   2. enalika-motion.js is told to skip .en-cine and .en-band. It writes a transform,
      which would fight the band parallax and re-hide the hero copy this file reveals. */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function onScroll(fn) {
    var ticking = false;
    function handler() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { fn(); ticking = false; });
    }
    document.addEventListener('scroll', handler, { passive: true, capture: true });
    window.addEventListener('resize', handler, { passive: true });
    fn();
  }

  function clamp01(n) { return n < 0 ? 0 : n > 1 ? 1 : n; }

  /* Autoplay is blocked in some contexts even when muted; nudge it, and if the
     nudge is rejected leave the poster showing rather than a dead black box. */
  function video() {
    var v = document.querySelector('.en-cine__video');
    if (!v) return;
    v.muted = true;
    v.playsInline = true;
    var p = v.play();
    if (p && typeof p.catch === 'function') p.catch(function () {});
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) { var q = v.play(); if (q && q.catch) q.catch(function () {}); }
    });
  }

  /* Slow counter-scroll on band imagery. Moves the wrapper, never the <img>. */
  function bands() {
    if (reduced) return;
    var media = [].slice.call(document.querySelectorAll('.en-band__media'));
    if (!media.length) return;
    onScroll(function () {
      for (var i = 0; i < media.length; i++) {
        var sec = media[i].parentElement;
        var r = sec.getBoundingClientRect();
        if (r.bottom < -200 || r.top > window.innerHeight + 200) continue;
        var mid = r.top + r.height / 2 - window.innerHeight / 2;
        media[i].style.transform = 'translate3d(0,' + (mid * -0.09).toFixed(2) + 'px,0)';
      }
    });
  }

  /* Split a heading into words and light them up as it crosses the viewport. */
  function wordLight(el) {
    if (!el || el.dataset.split) return;
    el.dataset.split = '1';
    var words = el.textContent.trim().split(/\s+/);
    el.textContent = '';
    words.forEach(function (w, i) {
      var s = document.createElement('span');
      s.className = 'en-word';
      s.textContent = w;
      el.appendChild(s);
      if (i < words.length - 1) el.appendChild(document.createTextNode(' '));
    });
    var spans = el.querySelectorAll('.en-word');
    if (reduced) {
      for (var i = 0; i < spans.length; i++) spans[i].classList.add('on');
      return;
    }
    onScroll(function () {
      var r = el.getBoundingClientRect();
      var start = window.innerHeight * 0.9;
      var end = window.innerHeight * 0.36;
      var prog = clamp01((start - r.top) / (start - end));
      var lit = Math.round(prog * spans.length);
      for (var i = 0; i < spans.length; i++) spans[i].classList.toggle('on', i < lit);
    });
  }

  /* enalika-motion.js deliberately skips .en-cine, so nothing else ever adds the
     .en-in that releases the masked headline lines. Do it here, on a short delay
     so the rise is seen rather than missed. */
  function copyIn() {
    var copy = document.querySelector('.en-cine__copy');
    if (!copy) return;
    if (reduced) { copy.classList.add('en-in'); return; }
    setTimeout(function () { copy.classList.add('en-in'); }, 140);
  }

  /* The theme's --header-group-height only covers the announcement bar; the nav row
     itself reports zero height, so the hero would slide under the logo. Measure the
     real bottom of the header group instead and expose it as --en-top. */
  function headerPad() {
    function measure() {
      var hg = document.getElementById('header-group');
      var bottom = 0;
      if (hg) {
        hg.querySelectorAll('*').forEach(function (el) {
          var cs = getComputedStyle(el);
          /* the mobile menu drawer is laid out but visibility:hidden - ignore it,
             or the hero gets padded down by the whole collapsed nav list */
          if (cs.visibility === 'hidden' || cs.display === 'none') return;
          var b = el.getBoundingClientRect().bottom;
          if (b > bottom && b <= 260) bottom = b;
        });
      }
      document.documentElement.style.setProperty('--en-top', Math.round(bottom || 96) + 'px');
    }
    measure();
    window.addEventListener('load', measure);
    window.addEventListener('resize', measure, { passive: true });
  }

  /* The header inherits a single cream colour for logo, links and icons, which is
     invisible against the light hero. Flag the body while the hero is still under the
     header so the CSS can swap that text to ink, and swap it back over the dark sections. */
  function headerTone() {
    var sec = document.querySelector('.en-cine');
    var wrap = document.querySelector('.page-wrapper');
    onScroll(function () {
      /* The header floats over the page. Flag the moment anything starts sliding under
         it so the CSS can fade in a backdrop, otherwise the nav sits directly on top of
         the hero copy. Same scroller quirk as everywhere else: .page-wrapper, not window. */
      var y = (wrap && wrap.scrollHeight - wrap.clientHeight > 40)
        ? wrap.scrollTop
        : (window.scrollY || (document.scrollingElement || document.documentElement).scrollTop || 0);
      document.body.classList.toggle('en-scrolled', y > 8);

      if (!sec) return;
      var top = parseFloat(
        getComputedStyle(document.documentElement).getPropertyValue('--en-top')
      ) || 96;
      document.body.classList.toggle('en-light-head', sec.getBoundingClientRect().bottom > top);
    });
  }

  function boot() {
    headerPad();
    headerTone();
    video();
    copyIn();
    bands();
    document.querySelectorAll('.en-band__text').forEach(wordLight);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
